import React from 'react'
import {bindActionCreators} from "redux";
import * as Actions from "../../../actions/Actions";
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import strings from "../../../localization";
import Page from "../../../common/Page";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Validators from "../../../constants/ValidatorTypes";
import {login} from "../../../base/OAuth";
import history from "../../../history";
import AdminLoginForm from "../../../components/forms/admin/login/AdminLoginForm";
import {Divider} from "@material-ui/core";
import {resetPasswordRequest} from "../../../services/UserService";
import {withSnackbar} from "notistack";


class AdminLogin extends Page {

    validationList = {
        email: [ {type: Validators.EMAIL } ],
        password: [ {type: Validators.REQUIRED } ]
    };

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            errors: {},
            redirectUrl: props.location.state ? props.location.state.redirectUrl : '/',
            forgotPassword: false
        };

        this.props.changeFullScreen(true);

        this.keyPress = this.keyPress.bind(this);
        this.onForgotPassword = this.onForgotPassword.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
    }

    componentDidMount() {

        if(this.getUser()) {
            this.props.history.push('/');
        }
    }

    keyPress(event) {

        if(event.key == 'Enter') {
            this.login()
        }
    }

    login() {

        if(!this.validate()) {
            return;
        }

        login(this.state.data.email, this.state.data.password).then(response => {

            if(!response.ok) {

                this.setError('email', strings.login.wrongCredentials);
                return;
            }

            this.props.login(response.data.user);

            setTimeout(()=> {
                history.push('/admin');
                window.location.reload(true);
            }, 1000)
        });
    }

    redirectToCreateAccount(){
        history.push('/register');
    }

    onForgotPassword(){
        this.setState({
            forgotPassword: true
        })
    }

    resetPassword(){
        // resetPasswordRequest(this.state.data).then(response => {
        //     if (!response.ok) {
        //         this.props.enqueueSnackbar(strings.login.error, { variant: 'error' });
        //         return;
        //     }
        //
        //     this.props.enqueueSnackbar(strings.login.success, { variant: 'success' })
        //
        //     this.fetchData();
        // });
    }

    render() {
        return (
            <div id='admin-login'>
                <Grid container spacing={24} className={'admin-login-wrapper'}>
                    {
                        this.state.forgotPassword
                        ?
                        <h1 className={'mobile-title'}>{ strings.login.forgotPasswordTitle }</h1>
                        :
                        <h1 className={'mobile-title'}>{ strings.login.loginTitle }</h1>
                    }
                    <Grid item md={3} className={'left-image'}>
                        <img src={'/images/illustracija2.svg'} />
                    </Grid>
                    <Grid item md={3} className={'admin-login-form-wrapper'}>
                        <Paper className='paper'>
                            {
                                this.state.forgotPassword
                                ?
                                <h1 className={'desktop-title'}>{ strings.login.forgotPasswordTitle }</h1>
                                :
                                <h1 className={'desktop-title'}>{ strings.login.loginTitle }</h1>
                            }
                            <AdminLoginForm onSubmit={ () => this.login() } onChange={ this.changeData }
                                            keyPress={ this.keyPress }
                                            data={ this.state.data } errors={ this.state.errors }
                                            onForgotPassword={this.onForgotPassword} forgotPassword={this.state.forgotPassword}
                                            resetPassword={this.resetPassword}
                            />
                        </Paper>
                        <div className={'privacy-terms'}>
                            <a href={'/privacy-policy'}><p> {strings.login.privacyPolicy}</p></a> <div className={'dot'}></div> <a href={'/terms-of-services'}><p>{ strings.login.termsOfService }</p></a>
                        </div>
                    </Grid>
                </Grid>

                <div className={'privacy-terms-wrapper'}>
                    <Divider />
                    <Grid item md={3} className={'privacy-terms'}>
                        <a href={'/privacy-policy'}>{ strings.login.privacyPolicy }</a>
                        <div></div>
                        <a href={'/terms-of-services'}>{ strings.login.termsOfService }</a>
                    </Grid>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        changeFullScreen: Actions.changeFullScreen,
        login: Actions.login
    }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers })
{
    return { menu: menuReducers, auth: authReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminLogin)));